var path = 'C:/Projects/repos/NAERS-Web/src/components/app/products/product-label-preview/product-label-preview.html';
var html = "<md-button ng-href={{$ctrl.label.DownloadUrl}} ng-if=\"$ctrl.product.hasPDFLabel && $ctrl.label\" aria-label=\"Download Product Label\" class=md-icon-button> <md-tooltip>Download Product Label</md-tooltip> <md-icon md-font-set=material-icons class=md-primary> insert_drive_file </md-icon> </md-button> <img style=width:50px;height:50px;margin:2px src=" + require("./loading.gif") + " ng-if=\"$ctrl.product.hasLabel && !$ctrl.product.hasPDFLabel\" ng-src={{$ctrl.imageArr}} ng-click=$ctrl.previewLabelImage($ctrl.product.ProductId)> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/products/product-label-preview/product-label-preview.html
// module id = 689
// module chunks = 0